<template>
  <div>
    <div id="RecruitmentDetail" v-for="(item, index) in dataList" :key="index">
      <div class="top">
        <div class="topCuntent">
          <div class="left">{{ item.drugName }}</div>
          <div
            class="right"
            :style="{
              color: textColor[item.clinicTrialStatus],
              background: bgColor[item.clinicTrialStatus],
            }"
          >
            {{ item.clinicTrialStatus }}
          </div>
        </div>
      </div>
      <div class="shadow"></div>
      <div class="bottom">
        <div class="bottomCuntent">
          <div class="left">
            <div class="leftTop">适应症</div>
            <div class="rightBottom">{{ item.cancerName }}</div>
          </div>
          <div class="right">
            <div class="leftTop">临床试验分期</div>
            <div class="rightBottom">{{ item.clinicTrialStages }}</div>
          </div>
        </div>
        <div class="bottomCuntent">
          <div class="cuntent">
            <div class="leftTop">临床实验地点</div>
            <div class="rightBottom">{{ item.clinicTrialSite }}</div>
          </div>
        </div>
        <div class="bottomCuntent">
          <div class="left">
            <div class="leftTop">临床试验信息</div>
            <div style="color:#4B84FF" class="rightBottom">{{ item.clinicTrialTwo }}</div>
          </div>
        </div>
        <div class="bottomCuntent">
          {{ item.clinicTrialOne }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataList: {
      type: Array,
    },
  },
  components: {},
  data() {
    return {
      bgColor: {
        "进行中（招募中）": "#FFF8DA",
        已完成: "#E2F8FE",
        "进行中（招募完成）": "#FFECEF",
        "进行中（尚未招募）": "#EFEAFF",
      },
      textColor: {
        "进行中（招募中）": "#FFB026",
        已完成: "#28D4E5",
        "进行中（招募完成）": "#FF627F",
        "进行中（尚未招募）": "#7C67E6",
      },
    };
  },
  methods: {},
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
#RecruitmentDetail {
  margin-bottom: 20px;
  background: #f4f8fd;
  border-radius: 10px;
  overflow: hidden;
  padding-bottom: 30px;
  .top {
    height: 70px;
    width: 100%;
    display: flex;
    align-items: center;
    background: #f4f8fd;
    position: relative;
    font-size: 15px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #2f354d;
    line-height: 22px;
    &::before {
      content: "";
      width: 3px;
      height: 14px;
      position: absolute;
      left: 0;
      top: 50%;
      margin-top: -7px;
      background: #2f354d;
      border-radius: 0px 2px 2px 0px;
    }
    .topCuntent {
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0 24px;

      .left {
        font-size: 15px;
        font-weight: 500;
        color: #2f354d;
        line-height: 22px;
      }
      .right {
        padding: 0;
        border-radius: 4px;
        padding: 0 8px;
        font-size: 13px;
      }
    }
  }
  .shadow {
    width: 100%;
    height: 20px;
    background: linear-gradient(
      360deg,
      rgba(58, 74, 134, 0) 0%,
      rgba(58, 74, 134, 0.1) 100%
    );
  }
  .bottom {
    padding: 0 24px;
    .bottomCuntent {
      display: flex;
      margin-top: 20px;
      font-size: 13px;
      color: #5f697d;
      text-align: justify;
      .left {
        flex: 1;
      }
      .right {
        // margin-left: 92px;
        flex: 1;
      }
      .leftTop {
        font-size: 12px;
        color: #a4a9bf;
      }
      .rightBottom {
        color: #2f354d;
        font-size: 13px;
        font-weight: 500;
        margin-top: 4px;
      }
      
    }
  }
}
</style>
